import './HexMap.css';
import { HexMapData } from '../lib/interfaces';
import MapTile from './MapTile';
import { useRecoilState } from 'recoil';
import { hexDetailIdAtom } from '../lib/atoms';
// import HexDetail from './HexDetail';

interface HexMapProps {
    hexMap: HexMapData;
}

export default function HexMap({ hexMap }: HexMapProps) {
    const [, setHexDetailId] = useRecoilState(hexDetailIdAtom);

    return <div className="hex-map" onClick={() => setHexDetailId(0)}>
        {
            hexMap.hexes.map(hex =>
                hex.id > 0 &&
                <MapTile key={hex.id} hexData={hex} blank={hex.order > hexMap.current} />)
        }
        {/* <HexDetail hexData={hexMap.hexes[hexDetailId]} /> */}
    </div>;
}